const aspectRatioPadding = (width: number, height: number): string => {
  const value = ((Math.round(height) / Math.round(width)) * 100).toFixed(2);
  return `${value}%`;
};

export default aspectRatioPadding;
